import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Org, OrgApiResponse } from '../models/org.model';

@Injectable({
  providedIn: 'root',
})
export class OrgService {
  private apiUrl = `${environment.glassApiUrl}/v2/orgs`;

  constructor(private http: HttpClient) {}

  getOrgs(): Observable<OrgApiResponse> {
    return this.http.get<OrgApiResponse>(this.apiUrl);
  }

  createOrg(org: Partial<Org>): Observable<OrgApiResponse> {
    return this.http.post<OrgApiResponse>(this.apiUrl, org);
  }

  updateOrg(id: string, org: Partial<Org>): Observable<OrgApiResponse> {
    return this.http.put<OrgApiResponse>(`${this.apiUrl}/${id}`, org);
  }

  deleteOrg(id: string): Observable<OrgApiResponse> {
    return this.http.delete<OrgApiResponse>(`${this.apiUrl}/${id}`);
  }

  /** Team members may append a freeze; server enforces org membership. */
  appendChangeFreeze(
    orgId: string,
    body: { title: string; startDate: string; endDate: string },
  ): Observable<OrgApiResponse> {
    return this.http.post<OrgApiResponse>(`${this.apiUrl}/${orgId}/change-freezes`, body);
  }
}
